import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import styles from "../styles/CommunityPage.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import DiscussionCard from "../components/DiscussionCard";
import { getDiscussionsForWorkflow, getWorkflowById } from "../api/api";
import { OrbitProgress } from "react-loading-indicators";

const CommunityPage = () => {
  const [filter] = useState("All");
  const [filterClosed, setFilterClosed] = useState(false);
  const [viewClosed, setViewClosed] = useState(false);

  const { id } = useParams();
  const [workflow, setWorkflow] = useState(null);
  const [discussions, setDiscussions] = useState(null);
  const [filteredDiscussions, setFilteredDiscussions] = useState([]);
  const [numberOfClosedDiscussions, setNumberOfClosedDiscussions] = useState(0);

  useEffect(() => {
    const foundWorkflow = getWorkflowById(id);
    setWorkflow(foundWorkflow);
    // const discussionz = getDiscussions();
    // setDiscussions(discussionz);
    // getFilteredDiscussions(discussionz);
    // getNumberOfClosedDiscussions(discussionz);
    // setDiscussions([]);
    // getFilteredDiscussions([]);
    // getNumberOfClosedDiscussions([]);

    const fetchDiscussions = async () => {
      try {
        const foundDiscussions = await getDiscussionsForWorkflow(id);
        setDiscussions(foundDiscussions);
        getFilteredDiscussions(foundDiscussions);
        getNumberOfClosedDiscussions(foundDiscussions);
      } catch (error) {
        console.error("Error fetching discussions:", error);
      }
    };

    fetchDiscussions();
  }, [id]);

  useEffect(() => {
    if (discussions === null) return;
    getFilteredDiscussions(discussions);
  }, [filterClosed, viewClosed]);

  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/workflow/${id}/community/new`, {});
  };

  const getFilteredDiscussions = (discussions) => {
    const filteredDiscussions = discussions.filter(
      (discussion) =>
        (filter === "All" || discussion.type === filter) &&
        discussion.closed === filterClosed
    );
    setFilteredDiscussions(filteredDiscussions);
  };

  const getNumberOfClosedDiscussions = (discussions) => {
    const numberOfClosedDiscussions = discussions.filter(
      (discussion) => discussion.closed
    ).length;
    setNumberOfClosedDiscussions(numberOfClosedDiscussions);
  };

  // if (!workflow) return <div></div>;
  if (!workflow || !discussions) return <div className={styles.communityPageLoading}><OrbitProgress color="#cb95fa" size="large" text="Loading" textColor="" /></div>;

  return (
    <div className={styles.discussionsPage}>
      {/* Left Column */}
      <div className={styles.leftColumn}>
        <button className={styles.actionButton} onClick={handleCardClick}>
          <FontAwesomeIcon icon={faPlus} /> New Discussion
        </button>
        {/* <button className={styles.actionButton}>
          <FontAwesomeIcon icon={faCodeBranch} /> New Pull Request
        </button> */}
        {/* {
        <div className={styles.resources}>
          <h3 className={styles.resourcesTitle}>Resources</h3>
          <ul className={styles.resourcesList}>
            <li>
              <a href="#">Resource 1</a>
            </li>
            <li>
              <a href="#">Resource 2</a>
            </li>
            <li>
              <a href="#">Resource 3</a>
            </li>
          </ul>
        </div>
} */}
      </div>

      {/* Right Column */}
      <div className={styles.rightColumn}>
        {/* Header Row */}
        <div className={styles.headerRow}>
          {/* <div className={styles.filterButtons}>
            {["All", "Discussion", "Pull Request"].map((filterName) => (
              <button
                key={filterName}
                className={`${styles.filterButton} ${
                  filter === filterName ? styles.activeFilter : ""
                }`}
                onClick={() => setFilter(filterName)}
              >
                {filterName}
              </button>
            ))}
          </div> */}
          <div className={styles.viewClosed}>
            <input
              type="checkbox"
              id="viewClosed"
              checked={viewClosed}
              onChange={() => {
                setViewClosed(!viewClosed);
                setFilterClosed(!filterClosed);
              }}
            />
            <label htmlFor="viewClosed">
              View Closed ({numberOfClosedDiscussions})
            </label>
          </div>
        </div>

        {/* Discussion Cards */}
        <div className={styles.cards}>
          {filteredDiscussions.map((discussion, index) => (
            <DiscussionCard
              key={discussion.id}
              discussion={discussion}
              workflowId={id}
              index={index}
            />
          ))}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default CommunityPage;
